import request from '@/utils/request'

export function index(params) {
  return request({
      url: '/quiz/question-categories',
      method: 'get',
      params: params
  })
}


export function inventory(params) {
  return request({
      url: '/quiz/question-category/inventory',
      method: 'get',
      params
  })
}

export function show(id) {
  return request({
      url: `/quiz/question-categories/${id}`,
      method: 'get'
  })
}

export function store(data) {
  return request({
      url: '/quiz/question-categories',
      method: 'post',
      data
  })
}

export function update(data) {
  return request({
      url: `/quiz/question-categories/${data.id}`,
      method: 'put',
      data
  })
}

export function destroy(id) {
  return request({
      url: `/quiz/question-categories/${id}`,
      method: 'delete',
  })
}
